import { useState, useEffect } from 'react';
import axios from 'axios';
import MetaData from '../Layouts/MetaData';
import BackdropLoader from '../Layouts/BackdropLoader';
import { useLang, uiText } from '../../utils/i18n';

const mapsHref = (store) => {
    const query = store.addressZh || store.address;
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
};

const AboutUs = () => {
    const { lang } = useLang();
    const [page, setPage] = useState(null);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const { data } = await axios.get('/api/v1/about-page');
                setPage(data.page);
            } catch (error) {
                console.error('Failed to load About page', error);
            }
        };
        fetchPage();
    }, []);

    if (!page) return <BackdropLoader />;

    return (
        <>
            <MetaData title="About Us | 1313 Mart" />

            <main className="w-full sm:w-[90%] m-auto mt-16 sm:mt-8 mb-12 px-3 sm:px-0">

                <div className="bg-primary-green rounded-lg px-6 sm:px-12 py-12 text-white text-center mb-10">
                    <h1 className="text-3xl sm:text-4xl font-bold mb-3">{lang === 'zh' && page.heroTitleZh ? page.heroTitleZh : page.heroTitle}</h1>
                    <p className="text-sm sm:text-base opacity-90 max-w-2xl mx-auto">{lang === 'zh' && page.heroSubtitleZh ? page.heroSubtitleZh : page.heroSubtitle}</p>
                </div>

                <section className="mb-10">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4 border-l-4 border-primary-orange pl-3">{lang === 'zh' && page.rebrandTitleZh ? page.rebrandTitleZh : page.rebrandTitle}</h2>
                    <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8 text-gray-600 text-sm sm:text-base leading-relaxed" dangerouslySetInnerHTML={{ __html: lang === 'zh' && page.rebrandBodyHtmlZh ? page.rebrandBodyHtmlZh : page.rebrandBodyHtml }} />
                </section>

                <section className="mb-10">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4 border-l-4 border-primary-orange pl-3">{lang === 'zh' && page.storyTitleZh ? page.storyTitleZh : page.storyTitle}</h2>
                    <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8 text-gray-600 text-sm sm:text-base leading-relaxed" dangerouslySetInnerHTML={{ __html: lang === 'zh' && page.storyBodyHtmlZh ? page.storyBodyHtmlZh : page.storyBodyHtml }} />
                </section>

                <section className="mb-10">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4 border-l-4 border-primary-orange pl-3">{lang === 'zh' && page.missionTitleZh ? page.missionTitleZh : page.missionTitle}</h2>
                    <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8 text-gray-600 text-sm sm:text-base leading-relaxed" dangerouslySetInnerHTML={{ __html: lang === 'zh' && page.missionBodyHtmlZh ? page.missionBodyHtmlZh : page.missionBodyHtml }} />
                </section>

                <section className="mb-10">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4 border-l-4 border-primary-orange pl-3">{uiText('brandsWeDistribute', lang)}</h2>
                    <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8">
                        <div className="flex flex-wrap gap-2.5">
                            {page.brands.map((brand) => (
                                <span key={brand} className="bg-gray-50 border text-gray-700 text-sm px-3.5 py-1.5 rounded-full">{brand}</span>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="mb-10">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4 border-l-4 border-primary-orange pl-3">{uiText('ourStores', lang)}</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {page.stores.map((store, i) => (
                            <div key={i} className="bg-white rounded-lg shadow-sm p-5 flex flex-col gap-1.5">
                                <h3 className="font-semibold text-gray-800">{store.name}</h3>
                                <p className="text-sm text-gray-600">{store.address}</p>
                                {store.addressZh && <p className="text-xs text-gray-400">{store.addressZh}</p>}
                                {store.hours && <p className="text-xs text-gray-500 mt-1">{store.hours}</p>}
                                <a href={mapsHref(store)} target="_blank" rel="noopener noreferrer" className="text-xs text-primary-blue hover:underline mt-2 w-fit">{uiText('getDirections', lang)}</a>
                            </div>
                        ))}
                    </div>
                </section>

            </main>
        </>
    );
};

export default AboutUs;
